import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Flex, StyleProps } from '@bonusly/design-system';

import { ReactionTab } from './lib/reaction-tab';

interface TabCountProps extends StyleProps {
	tab: ReactionTab;
}

export const TabCount: FC<TabCountProps> = ({ tab, ...rest }) => {
	const { t } = useTranslation('common');

	return (
		<Flex direction="row" justifyContent="center" alignItems="center" {...rest}>
			{tab.icon ? <tab.icon /> : t('all')}
			<Box as="span" fontSize="md" fontWeight="medium" ml={2}>
				{tab.count}
			</Box>
		</Flex>
	);
};
